// Furniture Color Options Data
// Extracted from furniture color swatches image

const furnitureColors = [
  // Row 1
  { 
    id: 'maple', 
    name: 'Maple', 
    hex: '#E8D4B0',
    rgb: 'rgb(232, 212, 176)',
    category: 'Wood'
  },
  { 
    id: 'loft', 
    name: 'Loft', 
    hex: '#5C4033',
    rgb: 'rgb(92, 64, 51)',
    category: 'Wood'
  },
  { 
    id: 'red', 
    name: 'Red', 
    hex: '#A52A2A',
    rgb: 'rgb(165, 42, 42)',
    category: 'Bold'
  },
  { 
    id: 'cloud-10x', 
    name: 'Cloud (10x)', 
    hex: '#B8B8B0',
    rgb: 'rgb(184, 184, 176)',
    category: 'Neutral'
  },
  { 
    id: 'cherry', 
    name: 'Cherry', 
    hex: '#3E1F1F',
    rgb: 'rgb(62, 31, 31)',
    category: 'Wood'
  },
  
  // Row 2
  { 
    id: 'silver', 
    name: 'Silver', 
    hex: '#8B8B8B',
    rgb: 'rgb(139, 139, 139)',
    category: 'Neutral'
  },
  { 
    id: 'plywood-nod', 
    name: 'Plywood (nod)', 
    hex: '#D4C5A9',
    rgb: 'rgb(212, 197, 169)',
    category: 'Wood'
  },
  { 
    id: 'brown-slate', 
    name: 'Brown Slate', 
    hex: '#4A3C2E',
    rgb: 'rgb(74, 60, 46)',
    category: 'Wood'
  },
  { 
    id: 'black-pearl-50', 
    name: 'Black Pearl (50)', 
    hex: '#2F4F4F',
    rgb: 'rgb(47, 79, 79)',
    category: 'Classic'
  },
  { 
    id: 'black', 
    name: 'Black', 
    hex: '#1A1A1A',
    rgb: 'rgb(26, 26, 26)',
    category: 'Classic'
  },
  
  // Row 3
  { 
    id: 'almond', 
    name: 'Almond', 
    hex: '#F5E6D3',
    rgb: 'rgb(245, 230, 211)',
    category: 'Neutral'
  },
  { 
    id: 'blue', 
    name: 'Blue', 
    hex: '#1C3A52',
    rgb: 'rgb(28, 58, 82)',
    category: 'Bold'
  },
  { 
    id: 'victoria-plant', 
    name: 'Victoria Plant', 
    hex: '#6B5D4F',
    rgb: 'rgb(107, 93, 79)',
    category: 'Wood'
  },
  { 
    id: 'auburn', 
    name: 'Auburn', 
    hex: '#7C3C2E',
    rgb: 'rgb(124, 60, 46)',
    category: 'Wood'
  },
  { 
    id: 'pink', 
    name: 'Pink', 
    hex: '#F4C2C2',
    rgb: 'rgb(244, 194, 194)',
    category: 'Pastel'
  },
  
  // Row 4
  { 
    id: 'diwani', 
    name: 'Diwani', 
    hex: '#2B2B2B',
    rgb: 'rgb(43, 43, 43)',
    category: 'Wood'
  },
  { 
    id: 'white', 
    name: 'White', 
    hex: '#F5F5F5',
    rgb: 'rgb(245, 245, 245)',
    category: 'Classic'
  },
  { 
    id: 'oakwood', 
    name: 'Oakwood', 
    hex: '#A89F91',
    rgb: 'rgb(168, 159, 145)',
    category: 'Wood'
  },
  { 
    id: 'oak', 
    name: 'Oak', 
    hex: '#C19A6B',
    rgb: 'rgb(193, 154, 107)',
    category: 'Wood'
  },
  { 
    id: 's-oak', 
    name: 'S.Oak', 
    hex: '#3D3D3D',
    rgb: 'rgb(61, 61, 61)',
    category: 'Wood'
  },
  
  // Row 5
  { 
    id: 'mocha', 
    name: 'Mocha', 
    hex: '#3E3531',
    rgb: 'rgb(62, 53, 49)',
    category: 'Wood'
  },
  { 
    id: 'market-oak', 
    name: 'Market Oak', 
    hex: '#8B7D6B',
    rgb: 'rgb(139, 125, 107)',
    category: 'Wood'
  },
  { 
    id: 'smokewood', 
    name: 'Smokewood', 
    hex: '#654321',
    rgb: 'rgb(101, 67, 33)',
    category: 'Wood'
  },
  { 
    id: 'chocolate', 
    name: 'Chocolate', 
    hex: '#3E2723',
    rgb: 'rgb(62, 39, 35)',
    category: 'Classic'
  },
  { 
    id: 'sugarcane', 
    name: 'Sugarcane', 
    hex: '#D2A76D',
    rgb: 'rgb(210, 167, 109)',
    category: 'Wood'
  }
];

// Helper function to get color by ID
export const getColorById = (id) => {
  return furnitureColors.find(color => color.id === id);
};

// Helper function to get color by name
export const getColorByName = (name) => {
  return furnitureColors.find(color => 
    color.name.toLowerCase() === name.toLowerCase()
  );
};

// Helper function to search colors
export const searchColors = (searchTerm) => {
  if (!searchTerm) return furnitureColors;
  
  const term = searchTerm.toLowerCase();
  return furnitureColors.filter(color => 
    color.name.toLowerCase().includes(term) ||
    color.category.toLowerCase().includes(term)
  );
};

// Helper function to group colors by category
export const getColorsByCategory = () => {
  const grouped = {};
  
  furnitureColors.forEach(color => {
    if (!grouped[color.category]) {
      grouped[color.category] = [];
    }
    grouped[color.category].push(color);
  });
  
  return grouped;
};

// Color categories in display order
export const colorCategories = [
  'Wood',
  'Classic',
  'Neutral',
  'Bold',
  'Pastel'
];

// Named export for the array
export { furnitureColors };

// Default export
export default furnitureColors;